// src/pages/LogoutPage.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authApi } from '../axiosInstance'; // <- vorkonfiguriert nutzen (unverändert importiert)
import Logo from '../components/Logo';

function LogoutPage({ onUserChange }) {
  const [msg, setMsg] = useState(''); // immer String
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    let alive = true;

    // ✅ Anpassung: Logout als echte Navigation (kein XHR), damit 303 sauber abgewickelt wird
    try {
      // App-Auth-Status sofort lokal zurücksetzen (falls übergeben)
      onUserChange?.(null);

      // UI-Status setzen
      if (alive) setMsg(t('logout.loggingOut', 'Melde ab …'));

      // echte Navigation auf den Logout-Endpunkt (Browser folgt Redirects korrekt)
      window.location.assign('/auth/logout');
    } catch (err) {
      // Falls etwas schiefgeht: Message setzen und fallback
      if (alive) setMsg(t('logout.error', 'Abmeldung fehlgeschlagen.'));

      setTimeout(() => {
        try {
          navigate('/login', { replace: true });
        } catch {
          window.location.assign('/login');
        }
      }, 250);
    }

    // Safety-Fallback: falls Navigation blockiert wird (selten), nach kurzer Zeit zum Login
    const timer = setTimeout(() => {
      try {
        navigate('/login', { replace: true });
      } catch {
        window.location.assign('/login');
      }
    }, 1500);

    return () => {
      alive = false;
      clearTimeout(timer);
    };
  }, [navigate, onUserChange, t]);

  // Beim Rendern sicherstellen, dass nur ein String in JSX landet
  const safeMsg = typeof msg === 'string' && msg ? msg : t('logout.loggingOut', 'Melde ab …');

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center p-6 text-white">
      <div className="mb-10">
        <Logo variant="wordmark" size="xxxl" />
      </div>

      <h2 className="text-3xl md:text-4xl font-bold mb-8">
        {t('logout.heading', 'Abmelden')}
      </h2>

      <div className="bg-gray-800 p-6 rounded-2xl shadow-md w-full max-w-md text-center">
        <p className="text-lg text-mentixxgreen font-bold">
          {safeMsg}
        </p>
        <p className="text-sm text-gray-400 mt-4">
          {t('logout.redirectNotice', 'Du wirst gleich weitergeleitet …')}
        </p>
      </div>
    </div>
  );
}

export default LogoutPage;
